import HomeHero from "../components/home/hero";
import SupervisorDashboard from "../components/home/SupervisorDashboard";
import { useStateValue } from "../context/StateProvider";

function Home() {
  const [{ user }] = useStateValue();
  return (
    <div>
      {user?.role === "Supervisor" ? <SupervisorDashboard /> : <HomeHero />}
    </div>
  );
}

export default Home;
// import HomeHero from "../components/home/hero";
// import GoalsHome from "../components/home/goals-home";
// import { useStateValue } from "../context/StateProvider";

// function Home() {
//   const [{ user }] = useStateValue();

//   return <div>{user?.role === "Employee" ? <GoalsHome /> : <HomeHero />}</div>;
// }

// export default Home;
